import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import messages from "../../../../../assets/locale/messages";
import Tabs from "../../../../../components/Tabs";
import {
  checkForMultiline,
  isRichText,
  RichTextToHTML
} from "../../../../../utils/Helpers";

const OverviewSection = ({ description, specifications }) => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    products: { productDetails }
  } = messages[lang];

  const [tabValue, setTabValue] = useState(0);
  const [tabsArray, setTabsArray] = useState([]);

  const renderSpecifications = () => (
    <div className="specs-container">
      {specifications?.map(({ SpecificationOtherName, Value }, i) => (
        <div
          className={`row py-3 px-2 ${i % 2 !== 0 && "faint-blue-bg"}`}
          key={`specs-${i}`}>
          <div className="col-xl-3 col-lg-4 col-md-5 col-6">
            <p className="text-color mb-0">
              {SpecificationOtherName}
            </p>
          </div>
          <div className="col-xl-9 col-lg-8 col-md-7 col-6">
            {SpecificationOtherName === "Catalogue" ? (
              <a
                className="primary-link"
                href={Value}
                download={"product_catalogue"}
                target="_blank"
                rel="noreferrer">
                {productDetails.downloadTheCatalogue}
              </a>
            ) : (
              <p className="title-color fweight-500 mb-0">{Value}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );

  useEffect(() => {
    const descriptionTab = {
      id: 0,
      label: productDetails.description,
      content: isRichText(description) ? (
        <span
          className="d-block mb-3 fsize-16 text-color pt-4"
          dangerouslySetInnerHTML={
            description
              ? RichTextToHTML(checkForMultiline(description))
              : ""
          }></span>
      ) : (
        <span className="d-block mb-3 fsize-16 text-color pt-4">
          {description ? checkForMultiline(description) : ""}
        </span>
      )
    };
    const specsTab = {
      id: 1,
      label: productDetails.specifications,
      content: <div>{renderSpecifications()}</div>
    };
    if (description && specifications?.length) {
      setTabsArray([descriptionTab, specsTab]);
    } else if (description) {
      setTabsArray([descriptionTab]);
    } else if (specifications?.length) {
      setTabsArray([specsTab]);
    }
  }, [description, specifications]);

  return (
    <div className="overview-section mb-4 p-4 faint-grey-border border-radius-10">
      <h6 className="fsize-20 fweight-600 title-color mb-4">
        {productDetails.overview}
      </h6>
      <Tabs
        tabs={tabsArray}
        value={tabValue}
        handleChange={setTabValue}
      />
    </div>
  );
};

export default OverviewSection;

OverviewSection.propTypes = {
  description: PropTypes.string.isRequired,
  specifications: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.number,
      SpecificationOtherName: PropTypes.string,
      Value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  )
};
